import { object, refine, string } from 'src/lib/superstruct';
import isEmail from 'validator/es/lib/isEmail';

// Custom validator for comma-separated emails
const CommaSeparatedEmails = refine(string(), 'comma-separated-emails', (value) => {
  const emails = value.split(',').map(email => email.trim());
  
  if (emails.length === 0) {
    return 'At least one email address is required';
  }
  
  for (const email of emails) {
    if (!isEmail(email)) {
      return `Invalid email address: ${email}`;
    }
  }
  
  return true;
});

export const leadCaptureEmailSchema = object({
  email: CommaSeparatedEmails
});
